import { inject, Injectable } from '@angular/core';
import { OtherVendorsSalesEndpoints } from 'app/core/enums/endpoints';
import { ApiService } from 'app/services/api/api.service';
import { UtilsService } from 'app/services/utils.service';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class OtherVendorsSalesService {
    private _endpoint = OtherVendorsSalesEndpoints;
    private utils = inject(UtilsService);
    private _apiService = inject(ApiService);

    private apiUrl = environment.apiUrl;

    constructor() {}

    // ----------------------------------------------------------------------
    // @ Public methods
    // ----------------------------------------------------------------------

    // ----------------------------------------------------------------------
    // @ CRUD methods
    // ----------------------------------------------------------------------

    /**
     * @description
     * Get all other vendors sales
     * @returns
     */
    getAll(playdateId: number): Observable<any> {
        return this._apiService.getOne(this._endpoint.getAll, playdateId);
    }

    /**
     * @description
     * Get single other vendor sale
     * @returns
     */
    getOne(id: number): Observable<any> {
        return this._apiService.getOne(this._endpoint.getOne, id);
    }

    /**
     * @description
     * Create a new other vendor sale
     * @returns
     */
    create(otherVendorsSaleData: any): Observable<any> {
        return this._apiService.post(
            this._endpoint.create,
            otherVendorsSaleData
        );
    }

    /**
     * @description
     * Update an other vendor sale
     * @returns
     */
    update(otherVendorsSaleData: string): Observable<any> {
        return this._apiService.update(
            this._endpoint.patch,
            otherVendorsSaleData
        );
    }

    /**
     * @description
     * Delete an other vendor sale
     * @returns
     */
    delete(payload: any): Observable<any> {
        return this._apiService.deleteWithParam(this._endpoint.delete, payload);
    }
}
